import { Suspense } from 'react';
import { Container } from '@mui/material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { UnderstandMatches as UnderstandMatchesView } from '@modules/Matches/views/UnderstandMatches';

export const UnderstandMatches = () => {
  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <ErrorBoundary>
        <Suspense fallback={<BodyLoading height="60vh" />}>
          <UnderstandMatchesView />
        </Suspense>
      </ErrorBoundary>
    </Container>
  );
};
